// extracted by mini-css-extract-plugin
export default {"wrapper":"Message_wrapper__mUY92","blockMsg":"Message_blockMsg__jBj+F","avatar":"Message_avatar__QpZ-G","avatarBg":"Message_avatarBg__Y5YDK","nameAuthor":"Message_nameAuthor__2U2Nd"};